<template>
  <MobileMenuItem
    :key="item.id"
    :item="item"
    :panel="true"
    :is-ibp="isIbp"
    :is-user-logged="isUserLogged"
    :logout-text="logoutText"
  >
    <template #panel>
      <MobileMenuItem
        v-for="(subitem, index) in item.subitems"
        :key="index"
        :item="{
          ...subitem,
          url: subitem.url.path ? subitem.url.path : subitem.url,
          target: '_self',
        }"
      >
      </MobileMenuItem>
    </template>
  </MobileMenuItem>
</template>
<script>
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileMenuItemWithChildren'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
  },
  props: {
    item: Object,
    isUserLogged: Boolean,
    isIbp: Boolean,
    logoutText: String,
  },
}
</script>
